import * as React from 'react';
import { Modal, ModalBody, ModalFooter, ModalSize, CustomButton, ButtonType, CustomSubmitButton, Form, Checkbox } from "soprasteria-ui-library";
import { IReferralResponseModel } from '../../../../models/IReferral';

interface IReferralCloseWithoutTreatmentsModal {
    canCloseReferralAsSysAdmin: boolean;
    closeReferral: (data: IReferralResponseModel) => void;
    closeReferralAsSysAdmin: (data: IReferralResponseModel) => void
    isSubmitting: boolean;
    isAgreementRequired: boolean;
    setIsAgreementRequired: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ReferralCloseWithoutTreatmentsModal: React.FunctionComponent<IReferralCloseWithoutTreatmentsModal> = ({ canCloseReferralAsSysAdmin, closeReferral, closeReferralAsSysAdmin, isSubmitting, isAgreementRequired, setIsAgreementRequired }) => {

    return (
        <Modal header="Avsluta specialistremiss" modalSize={ModalSize.normal} id="close-referral-modal-no-treatments">
            <ModalBody>
                <div className="text-left">
                    <p>Är du säker på att du vill avsluta specialistremissen utan att rapportera vård?</p>
                    <Checkbox value="agreement" label="Jag bekräftar att patienten ej kommer att behandlas" name="agreement" id="agreement" required={isAgreementRequired} labelCol={9} inputCol={3} />
                </div>
            </ModalBody>
            <ModalFooter>
                <CustomButton id="close-close-referral-modal-no-treatments" buttonType={ButtonType.general} buttonText="Stäng" data-dismiss="modal" onClick={() => setIsAgreementRequired(false)} />
                <CustomSubmitButton onButtonSubmit={canCloseReferralAsSysAdmin ? closeReferralAsSysAdmin : closeReferral} isLoading={isSubmitting}>Skicka remissvar och avsluta specialistremiss</CustomSubmitButton>
            </ModalFooter>
        </Modal>
    )
}